// src/utils/permissoesApp.js
//
// Helpers de PERMISSÃO NEGADA (v3.7.3): quando câmera/microfone/fotos estão
// bloqueados nas configurações, "tentar novamente" sozinho não resolve — o
// sistema nem volta a perguntar. O PermissionHelpModal usa estes helpers para
// mostrar o passo a passo da plataforma e abrir a tela de configurações DO
// APP direto.

import { Capacitor } from "@capacitor/core";
import { GeofenceService } from "../services/GeofenceService";

/** "ios" | "android" | "web" */
export function plataformaApp() {
  try {
    return Capacitor.getPlatform();
  } catch {
    return "web";
  }
}

/**
 * Abre a tela de configurações DO APP (iOS: Ajustes › LesVita; Android:
 * Informações do app). Reusa o openSettings do plugin nativo Geofence — ele já
 * abre a página GERAL do app nas duas plataformas (openSettingsURLString /
 * ACTION_APPLICATION_DETAILS_SETTINGS), onde ficam TODAS as permissões.
 */
export async function abrirConfiguracoesApp() {
  if (!Capacitor.isNativePlatform()) return false;
  try {
    await GeofenceService.openSettings();
    return true;
  } catch {
    if (plataformaApp() === "ios") {
      window.open("app-settings:");
      return true;
    }
    return false;
  }
}

/**
 * O erro veio de PERMISSÃO negada (e não de câmera ocupada/inexistente)?
 * Cobre getUserMedia (NotAllowedError/PermissionDeniedError/SecurityError),
 * o plugin @capacitor/camera ("User denied access…", "…permission…") e o
 * html5-qrcode (que às vezes rejeita com string).
 */
export function ehErroDePermissao(err) {
  if (!err) return false;
  const nome = typeof err === "object" ? String(err.name || "") : "";
  if (["NotAllowedError", "PermissionDeniedError", "SecurityError"].includes(nome)) {
    return true;
  }
  const msg = (typeof err === "string" ? err : String(err.message || "")).toLowerCase();
  return (
    msg.includes("permission denied") ||
    msg.includes("permission dismissed") ||
    msg.includes("denied access") ||
    msg.includes("not allowed") ||
    msg.includes("permissão negada") ||
    (msg.includes("permiss") && msg.includes("den"))
  );
}

const permissoesApp = { plataformaApp, abrirConfiguracoesApp, ehErroDePermissao };
export default permissoesApp;
